module.exports = __webpack_public_path__ + "img/송내 맛집.256d2aca.png";